import styled from 'vue-styled-components';
import { device } from './shared/utils/media';

export const MainContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto 100px;
  padding-top: 30px;
  z-index: 0;
  font-size: 16px;
  line-height: 1.5;
`;

export const InnerContainer = styled.div`
  margin: 0 auto;
  max-width: 1130px;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const Title = styled.h1`
  font-size: 2em;
  margin: 10px 5px;

  @media ${device.desktop} {
    font-size: 3em;
    margin: 0 0 40px;
  }
`;
